import { N as o } from "./index-Drmyqk9P.js";
const t = o.create({
  name: "doc",
  topNode: !0,
  content: "block+"
}), c = /* @__PURE__ */ t.extend({
  content: "(block|columns)+"
  // echo editor is a block editor
});
export {
  c as Document,
  c as default
};
